<div class="page-container">
    <div class="page-body-container">
		<div class="card login h-full md:h-auto md:w-4/6">
			<div class="card-header-container">
				<h1 class="card-header"> Anmelden</h1>
			</div>
			<div class="form-group">
				<div class="form-control">
					<label>Benutzername</label>
					<input type="email" matInput [formControl]="emailFormControl" [errorStateMatcher]="matcher"
						   placeholder="john.doe@example.com">
					<mat-hint>Ihr Benutzername entspricht Ihrer Emailadresse</mat-hint>
					@if (emailFormControl.hasError('required') && !emailFormControl.untouched) {
						<mat-error>* Pflichtfeld</mat-error>
					} @else if (emailFormControl.hasError('email')) {
						<mat-error>* E-Mail ist ungültig</mat-error>
					}
				</div>

				<div class="form-control">
					<label>Passwort</label>
					<input [type]="hidePassword ? 'password' : 'text'" matInput [formControl]="passwordFormControl"
						   [errorStateMatcher]="matcher" (keyup.enter)="onLogin()">
					<i class="fa-solid absolute right-3 top-11 text-preorder-accordion-background text-xl cursor-pointer"
					   (click)="hidePassword = !hidePassword"
					   [ngClass]="{'fa-eye': !hidePassword, 'fa-eye-slash': hidePassword}"></i>
					@if (passwordFormControl.hasError('required') && !passwordFormControl.untouched) {
						<mat-error>* Pflichtfeld</mat-error>
					}
				</div>
			</div>
			<a (click)="forgotPassword()" class="hover:underline">Passwort vergessen ?</a>
			<div class="flex flex-col gap-1 pt-8">
				<div class="text">Schon registriert aber keine Bestätigungsmail erhalten?</div>
				<div class="flex gap-1">
					<div class="text">Dann klicken Sie bitte</div>
					<div class="text underline cursor-pointer hover:text-canna-secondary" (click)="openResendLinkModal()">hier.</div>
				</div>
			</div>
			<div class="button-row border-none">
				<button class="btn-primary" (click)="onLogin()">
					<span>Anmelden</span>
					<i class="fa-solid fa-angle-right self-center text-md pl-2"></i>
				</button>
			</div>
		</div>
    </div>
</div>
